import PropTypes from 'prop-types';
import './InlineEdit.css';

export function InlineEdit({
  value,
  placeholder,
  variant = 'default',
  marker,
  markerType = 'warn',
  onChange,
  onBlur,
  disabled = false,
  title,
  'aria-label': ariaLabel,
}) {
  const cls = [
    'inline-edit',
    variant === 'warn-fix' && 'inline-edit--warn-fix',
    variant === 'error' && 'inline-edit--error',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className="inline-edit-cell">
      <input
        type="text"
        className={cls}
        value={value}
        placeholder={placeholder}
        onChange={onChange ? (e) => onChange(e.target.value) : undefined}
        onBlur={onBlur ? (e) => onBlur(e.target.value) : undefined}
        disabled={disabled}
        title={title}
        aria-label={ariaLabel}
        aria-invalid={variant === 'error'}
      />
      {marker && (
        <span className={`cell-marker cell-marker--${markerType}`}>
          {marker}
        </span>
      )}
    </span>
  );
}

InlineEdit.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'warn-fix', 'error']),
  marker: PropTypes.string,
  markerType: PropTypes.oneOf(['warn', 'error']),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  'aria-label': PropTypes.string,
};

export default InlineEdit;
